import alert from './alert';
import button from './button';
import type { CustomTheme } from '../../../types/custom-theme';

const banner = {
  alert,
  button,
};

export type BannerComponentsType = 'alert' | 'button';

export type BannerVariantsType = 'alert' | 'notice' | 'warning' | 'white' | 'announcement';
const baseBannerVariants = ['alert', 'notice', 'warning', 'white', 'announcement'] as BannerVariantsType[];

export const bannerVariants = {
  alert: baseBannerVariants,
  button: baseBannerVariants,
};

export interface BannerType {
  /** The Banner subcomponent types. */
  SubComponents: {
    [K in BannerComponentsType]: CustomTheme.VariantCSSKeys<BannerVariantsType>;
  };
  /** The Alert Banner subcomponent types. */
  Alert: CustomTheme.VariantKeys<BannerVariantsType>;
  /** The Button subcomponent types. */
  Button: CustomTheme.VariantKeys<BannerVariantsType>;
}

export default banner;
